import { createFeatureSelector, createSelector } from '@ngrx/store'

import { aggregationAnalysisFeatureKey, IAggregationAnalysisState } from './aggregation-analysis.state'

export const selectAggregationAnalysis = createFeatureSelector<IAggregationAnalysisState>(aggregationAnalysisFeatureKey)

// quarter
export const selectAggregationAnalysisQuarter = createSelector([selectAggregationAnalysis], state => state.quarter)

export const selectAggregationAnalysisQuarterInRequest = createSelector(
  [selectAggregationAnalysisQuarter],
  state => state.inRequest
)

export const selectAggregationAnalysisQuarterError = createSelector(
  [selectAggregationAnalysisQuarter],
  state => state.error
)

export const selectAggregationAnalysisQuarterData = createSelector(
  [selectAggregationAnalysisQuarter],
  state => state.data
)

export const selectAggregationAnalysisQuarterSelected = createSelector(
  [selectAggregationAnalysisQuarter],
  state => state.selected
)

// sector
export const selectAggregationAnalysisSector = createSelector([selectAggregationAnalysis], state => state.sector)

export const selectAggregationAnalysisSectorInRequest = createSelector(
  [selectAggregationAnalysisSector],
  state => state.inRequest
)

export const selectAggregationAnalysisSectorError = createSelector(
  [selectAggregationAnalysisSector],
  state => state.error
)

export const selectAggregationAnalysisSectorData = createSelector(
  [selectAggregationAnalysisSector],
  state => state.data
)

export const selectAggregationAnalysisSectorSortBy = createSelector(
  [selectAggregationAnalysisSector],
  state => state.sortBy
)

export const selectAggregationAnalysisSectorOrder = createSelector(
  [selectAggregationAnalysisSector],
  state => state.order
)

// aggregation type
export const selectAggregationAnalysisType = createSelector([selectAggregationAnalysis], state => state.aggType)
